@if (isCustomerEmulationSessionInProgress$ | async) {
   <div class="cx-asm-customerInfo">
      <label class="cx-asm-name">{{ customer?.name }}</label>
      <label class="cx-asm-uid">{{ customer?.uid }}</label>
   </div>
   @if (customer) {
      <siko-b2b-asm-bind-cart
         [customer]="customer"
      />
   }
   <button formcontrolname="logoutCustomer" (click)="logoutCustomer()">
      {{ 'asm.endSession' | cxTranslate }}
   </button>
}
